
export const overrides = new Map<string, string>([
	["lightgray", "#d1d1d1"],
	["red", "#f10351"]
])